// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__2pD5j"};